import { createHttpClient } from '@wix/fe-essentials/http-client';
const METASITE_APP_DEF_ID = '22bef345-3c5b-4c18-b782-74d4085112ff';
export function createViewerHttpClient({ appEnv, experiments, errorHandler, }) {
    const { platformEnv, appDefId, shouldElevateBlocksAppPermissions } = appEnv;
    const { isSSR, baseUrl, multilingualOptions, getAppToken } = platformEnv;
    const errorHandlerEnabled = experiments.get('specs.os.EnableErrorHandlerInViewer') === true ||
        experiments.enabled('specs.os.EnableErrorHandlerInViewer');
    return createHttpClient({
        isSSR,
        baseURL: isSSR ? baseUrl : undefined,
        multilingualOptions,
        getAppToken: () => getAppToken(shouldElevateBlocksAppPermissions ? METASITE_APP_DEF_ID : appDefId),
        errorHandler: errorHandlerEnabled ? errorHandler : undefined,
    });
}
//# sourceMappingURL=createViewerHttpClient.js.map